var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-link",
    {
      staticClass: "user",
      attrs: {
        to: {
          name: "view-user",
          params: { user_id: _vm.resource.id },
        },
      },
    },
    [
      _c("img", {
        key: _vm.resource.id,
        staticClass: "avatar avatar--small",
        attrs: {
          src: _vm.resource.avatar
            ? `/images/avatar/${_vm.resource.id}`
            : "//placehold.it/32x32",
          title: _vm.resource.name,
          alt: `${_vm.resource.name}'s avatar`,
          width: "32",
          height: "32",
        },
      }),
      _vm._v(" "),
      _vm.showName && _vm.resource.name
        ? _c("span", { domProps: { textContent: _vm._s(_vm.resource.name) } })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }